export class HandledException {
  constructor(
    public message?: string
  ) {

  }
}
